import Vue from 'vue'
import axiosConfig from '@/apps/axiosConfig'

// import Vee-validate
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import fr from 'vee-validate/dist/locale/fr'

// import external libraries
import vSelect from 'vue-select'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import 'bootstrap'

// import global ui components
import CollapseCard from '@/components/ui/CollapseCard'
import DateInput from '@/components/ui/DateInput'
import Modal from '@/components/ui/Modal'
import Notification from '@/components/ui/Notification'
import PhoneInput from '@/components/ui/PhoneInput'
import RequiredInput from '@/components/ui/RequiredInput'
import SubmitButton from '@/components/ui/SubmitButton'
import Wizard from '@/components/ui/Wizard'
import WizardStep from '@/components/ui/WizardStep'
import ZipCodeInput from '@/components/ui/ZipCodeInput'

// import styles
import 'bootstrap-vue/dist/bootstrap-vue.css'

const VueInputMask = require('vue-inputmask').default

for (let rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: fr.messages[rule]
  })
}
extend('size', {
  ...rules.size,
  message: 'La photo doit avoir un poids inférieur à 2Mo.'
})
extend('password', {
  validate: (value, { other }) => value === other,
  message: 'La confirmation du mot de passe ne correspond pas au mot de passe',
  params: [{ name: 'other', isTarget: true }]
})

Vue.use(BootstrapVue)
Vue.use(VueInputMask)

Vue.component('vv-observer', ValidationObserver)
Vue.component('vv-provider', ValidationProvider)
Vue.component('v-select', vSelect)

Vue.component('c-card', CollapseCard)
Vue.component('d-input', DateInput)
Vue.component('modal', Modal)
Vue.component('notification', Notification)
Vue.component('p-input', PhoneInput)
Vue.component('r-input', RequiredInput)
Vue.component('s-button', SubmitButton)
Vue.component('wizard', Wizard)
Vue.component('wizard-step', WizardStep)
Vue.component('zc-input', ZipCodeInput)

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('notSpecified', function (value) {
  if (value === null || typeof value === 'undefined') return 'non renseigné'
  if (typeof value === 'boolean') return value ? 'oui' : 'non'
  return value
})

Vue.prototype.$http = axiosConfig
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)
Vue.prototype.$regexPhone = /^0[1-9](?:[\s]*\d{2}){4}$/

Vue.config.productionTip = false
